
document.addEventListener('DOMContentLoaded', () => {
  const slideshow = document.querySelector('.custom-slideshow');
  if (!slideshow) return;

  const container      = slideshow.querySelector('.slides-container');
  const slides         = slideshow.querySelectorAll('.slide');
  const prev           = slideshow.querySelector('.prev');
  const next           = slideshow.querySelector('.next');
  const segments       = slideshow.querySelectorAll('.progress-segment');
  const progressFills  = slideshow.querySelectorAll('.progress-fill');
  const playPause      = slideshow.querySelector('.play-pause');

  let currentIndex = 0;
  let timer        = null;
  let isPlaying    = slideshow.dataset.autoplay === 'true';
  const duration   = parseInt(slideshow.dataset.speed, 10) * 1000;

  let startTime    = 0;
  let elapsed      = 0;
  let pausedByHover = false;

  // ─────────────── 工具函数 ───────────────
  function updateSegmentStyles() {
    segments.forEach((seg, i) => {
      seg.classList.toggle('short', i !== currentIndex);
    });
  }

  function clearOldProgress(oldIndex) {
    const oldFill = progressFills[oldIndex];
    if (oldFill) {
      oldFill.style.transition = 'none';
      oldFill.style.width = '0%';
      oldFill.offsetHeight;
    }
  }

  function goTo(index, resetProgress = true) {
    const oldIndex = currentIndex;
    currentIndex = (index + slides.length) % slides.length;
    container.style.transform = `translateX(-${currentIndex * 100}%)`;
    updateSegmentStyles();

    // 总是清空旧段
    clearOldProgress(oldIndex);

    if (resetProgress) {
      elapsed = 0;
      startTime = Date.now();

      progressFills.forEach((fill, i) => {
        if (i !== currentIndex) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      });
    }
  }

function updateHeaderThemeBySlide(slide) {
  const theme = slide.dataset.headerTheme || 'light';
  
  // 先移除旧类
  document.body.classList.remove('header-theme-light', 'header-theme-dark');
  // 加新类
  document.body.classList.add(`header-theme-${theme}`);
  
  // debug: 看是否执行 + 类是否加上了
  console.log('Theme switched to:', theme);
  console.log('Body classes now:', document.body.className);
  
  // 如果类是加在 header 上，改成这样：
  // const header = document.querySelector('header') || document.querySelector('.site-header');
  // header.classList.remove('header-theme-light', 'header-theme-dark');
  // header.classList.add(`header-theme-${theme}`);
}
  function startProgress(time = duration) {
    const fill = progressFills[currentIndex];
    if (!fill) return;

    startTime = Date.now() - elapsed;

    fill.style.transition = 'none';
    fill.style.width = `${(elapsed / duration) * 100}%`;
    fill.offsetHeight;

    fill.style.transition = `width ${time / 1000}s linear`;
    fill.style.width = '100%';
  }

  function pauseProgress() {
    if (!startTime) return;
    elapsed = Date.now() - startTime;
    const fill = progressFills[currentIndex];
    if (fill) {
      fill.style.transition = 'none';
      fill.style.width = `${Math.min((elapsed / duration) * 100, 100)}%`;
    }
  }

  function startAutoplay() {
    if (!isPlaying || pausedByHover) return;

    clearTimeout(timer);

    const remaining = duration - elapsed;

    timer = setTimeout(() => {
      elapsed = 0;
      goTo(currentIndex + 1, true);
      startAutoplay();
    }, remaining);

    playPause.textContent = '❚❚';
    startProgress(remaining);
  }

  function stopAutoplay() {
    clearTimeout(timer);
    timer = null;
    playPause.textContent = '▶';
    pauseProgress();
  }

  // ─────────────── hover 暂停 ───────────────
  slideshow.addEventListener('mouseenter', () => {
    if (!isPlaying) return;
    pausedByHover = true;
    clearTimeout(timer);
    pauseProgress();
  });

  slideshow.addEventListener('mouseleave', () => {
    if (!isPlaying) return;
    pausedByHover = false;
    startAutoplay();
  });

  // ─────────────── 手动切换事件 ───────────────
  prev.addEventListener('click', () => {
    stopAutoplay();               // 先完全停止当前 timer
    pauseProgress();              // 保存当前进度（可选，但保险）
    goTo(currentIndex - 1, true); // 强制重置进度为新开始（避免打架）
    if (isPlaying) {
      startAutoplay();            // 重新启动新 timer
    }
  });

  next.addEventListener('click', () => {
    stopAutoplay();
    pauseProgress();
    goTo(currentIndex + 1, true);
    if (isPlaying) {
      startAutoplay();
    }
  });

  segments.forEach((seg, idx) => {
    seg.addEventListener('click', () => {
      stopAutoplay();
      pauseProgress();
      goTo(idx, true);
      if (isPlaying) startAutoplay();
    });
  });

  playPause.addEventListener('click', () => {
    isPlaying = !isPlaying;
    if (isPlaying) {
      startAutoplay();
    } else {
      stopAutoplay();
    }
  });

  window.addEventListener('resize', () => {
    goTo(currentIndex, false);
  });

  // 初始化
  goTo(0, true);
  if (isPlaying) startAutoplay();
});